import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { actionSvgs, callbackSvgs } from 'assets/icons';

import ContentLoader from 'components/Informations/Loaders/ContentLoader';

import { nrleNumber } from 'utils/masks';

import useFetch from 'hooks/useFetch';
import endpoints from 'services/endpoints';

import * as S from './styles';

const { getEmployees } = endpoints;

function ClientsTable({ clients }) {
  const [isLoading, setIsLoading] = useState(false);

  const [accountManagers, setAccountManagers] = useState([]);

  const [allEmployees] = useFetch(getEmployees);

  useEffect(() => {
    (async () => {
      const response = await allEmployees;
      const filteredEmployees = response.filter(
        employee =>
          employee.id_funcao === 16 && employee.tipo_status === 'Ativo',
      );

      const isLoaded = !!filteredEmployees.length;

      setAccountManagers(filteredEmployees);
      setIsLoading(!isLoaded);
    })();
  }, [allEmployees]);

  const getAccountName = id => {
    const account = accountManagers?.find(employee => employee.id_funcionario === id);
    return account && account.nome;
  };

  return (
    <>
      {isLoading && (
        <S.Loader>
          <ContentLoader />
        </S.Loader>
      )}

      <S.Table>
        <div className="table-responsive">
          {!clients.length ? (
            <S.Callback>
              {callbackSvgs('interrogationWoman')}
              <S.CallbackText>
                Não foram encontrados resultados para esta pesquisa. Por favor,
                tente novamente
              </S.CallbackText>
            </S.Callback>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">CNPJ</th>
                  <th scope="col">Cliente</th>
                  <th scope="col">Gerente de contas</th>
                  <th scope="col">Status</th>
                  <th scope="col">Ações</th>
                </tr>
              </thead>
              <tbody>
                {clients.map(client => (
                  <tr key={client.id_cliente}>
                    <td>{nrleNumber(client.cnpj)}</td>
                    <td>{client.nome}</td>
                    <td>
                      {client.id_func_account_manager > 0
                        ? getAccountName(client.id_func_account_manager)
                        : 'Não cadastrado'}
                    </td>
                    <td
                      className={`status-${client.tipo_status.toLowerCase()}`}
                    >
                      {client.tipo_status}
                    </td>
                    <td>
                      <S.EditClient
                        to={{
                          pathname: 'clients/edit-client',
                          state: client,
                        }}
                      >
                        {actionSvgs('edit')}
                      </S.EditClient>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </S.Table>
    </>
  );
}

ClientsTable.defaultProps = {
  clients: [],
};

ClientsTable.propTypes = {
  clients: PropTypes.arrayOf(
    PropTypes.shape({
      id_cliente: PropTypes.number,
      nome: PropTypes.string,
      id_status_cliente: PropTypes.number,
      tipo_status: PropTypes.string,
      cnpj: PropTypes.string,
      id_func_account_manager: PropTypes.number,
      func_account_manager: PropTypes.string,
    }),
  ),
};

export default ClientsTable;
